<template>
<div>

    <Layout v-if="cstore.getCruiseBook.ok" :slotInfoLinkRooms="true" :CruiseBook="cstore.getCruiseBook.resolve">
        <template #boat="{hideInfoGrid}">
            <Overview :CruiseBook="cstore.getCruiseBook.resolve" @hideInfoGrid="v => hideInfoGrid(v)" />
        </template>
        <template #after>
            <transition name="fade-up">
                <BookCabins v-if="bookCabins.notEmpty()" :ForOverview="true" />
            </transition>
        </template>
    </Layout>

    <div v-if="cstore.getCruiseBook.wait" class="CruisePage__ifloader"><Loader class="CruisePage__loader" /></div>

    <div v-if="cstore.getCruiseBook.reject">! не удалось</div>
</div>
</template>

<script setup>
import {ref, unref, watch, computed, nextTick, onMounted} from 'vue' 
import {  useRoute } from 'vue-router/composables'
import Layout from '@/comp/CruiseHead/Layout.vue'
import useCruiseStore from '@/cstore.js'
import useCabinsStore from '@/bookCabins.js'
import Loader from '@/comp/Loader/Loader.vue'
import Overview from '@/comp/CruiseHead/Overview.vue'
import BookCabins from '@/comp/BookCabins/BookCabins.vue'


const cstore = useCruiseStore()
const bookCabins = useCabinsStore()
const route = useRoute()

watch( 
    [   
        () => route.query.cruiseIdFull,
    ],
    (   [cruiseIdFull], 
        [old_cruiseIdFull]
    ) => {
        if (!old_cruiseIdFull || cruiseIdFull !== old_cruiseIdFull) {
            if (!cstore.getCruiseBook.is || cruiseIdFull !== cstore.getCruiseBook.params.cruiseIdFull) {
                cstore.loadCruiseBook( { cruiseIdFull } )
            }
        }
    },
    { immediate: true }
)
</script>
